import { render, staticRenderFns } from "./VideoLogs.vue?vue&type=template&id=f1d732f4&scoped=true"
import script from "./VideoLogs.vue?vue&type=script&lang=js"
export * from "./VideoLogs.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f1d732f4",
  null
  
)

export default component.exports